@if (hasValidAccount) {
  <div id="ip-common">
    <header>
      @if (!isProduction) {
        <lib-environment-banner
          [environmentInfoText]="environmentInfoText$ | async"
        ></lib-environment-banner>
      }
      <lib-alert-info></lib-alert-info>
      <lib-notification-info></lib-notification-info>
      <lib-skip-to-content mainId="main-content"></lib-skip-to-content>
      <lib-site-header
        [site]="EtjansterSites.Bedom"
        [sitesToShow]="[
          EtjansterSites.Start,
          EtjansterSites.Ansok,
          EtjansterSites.Projekt,
          EtjansterSites.Bedom,
          EtjansterSites.MinProfil,
        ]"
        [authenticated]="hasValidAccount"
      ></lib-site-header>
      <lib-english-disclaimer></lib-english-disclaimer>
    </header>
    <main class="ip-body" id="main-content">
      <div class="container mt-5">
        <router-outlet></router-outlet>
      </div>
    </main>
    <lib-site-footer></lib-site-footer>
    @if (showChatbot) {
      <vinnova-chatbot-widget> </vinnova-chatbot-widget>
    }
  </div>
}
<lib-already-logged-in></lib-already-logged-in>
